import React from "react"
import '../styles/global.css'
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

export default function Layout({children}) {
  return (
    <div className="layout">
        <Navbar/>
        <div className ="content">
            {/* Contents of the page */}
            {children}
        </div>
        <Footer/>
    </div>

  )
}
